import FormField from "../form-field";

export default class TextField extends FormField {
    constructor(props = {}) {
        super(props);
    }

    _afterInit() {
        this.$input.addEventListener('input', this._handleInput.bind(this));
        this.$input.addEventListener('blur', this._handleBlur.bind(this));
        this._refresh();
    }

    _handleInput(e) {
        this.controller.setValue(e.target.value);
        this._setStatus(this.controller.valid ? 'valid' : 'neutral');
    }

    _handleBlur(e) {
        this._setStatus(this.controller.valid ? 'valid' : 'invalid');
    }

    _refresh() {
        this.$input.value = this.controller.getValue() || '';
        this.$input.dispatchEvent(new Event('input'));
    }
}